<template>
    <div class="container" v-if="!apiDocsLoaded">
      <Spinner class="spinner"/>
      <div class="label" v-if="label">{{label}}</div>
    </div>
</template>

<script>
import Spinner from './Spinner';

export default {
  name: 'SpinnerApiLoading',
  components: { Spinner },
  props: {
    label: {
      type: String,
      default: 'Loading API Docs'
    }
  },
  computed: {
    apiDocsLoaded () {
      return !!(this.$store.state.docs.db);
    }
  }
};
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .spinner {
    width: 32px;
    height: 32px
  }
  .label {
    margin: 0 1rem;
  }
</style>
